<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="套餐名称："
        prop="servicePackageName">
        <el-input v-model="info.servicePackageName"></el-input>
      </el-form-item>
      <el-form-item
        label="检测标准："
        prop="testStandard">
        <el-input
          v-model="info.testStandard"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
      <el-form-item
        label="检测内容："
        prop="features">
        <el-input
          v-model="info.features"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 6}"></el-input>
      </el-form-item>
      <el-form-item
        label="检测资质："
        prop="testQualification">
        <el-input
          v-model="info.testQualification"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
      <el-form-item
        label="抽样数量："
        prop="sampleQuantity">
        <el-input v-model="info.sampleQuantity"></el-input>
      </el-form-item>
      <el-form-item
        label="周期："
        prop="cycleDays">
        <el-input-number
          v-model="info.cycleDays"
          :precision="0"
          :min="0"
        ></el-input-number
        >天
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'EditPackageModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        serviceCategoryId: null,
        servicePackageId: null,
        servicePackageName: '',
        testStandard: '',
        features: '',
        testQualification: '',
        sampleQuantity: '',
        cycleDays: undefined
      },
      rules: {
        servicePackageName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' },
          { max: 15, message: '长度最多 15 个字符', trigger: 'blur' }
        ],
        testStandard: [
          { required: true, message: '请输入检测标准', trigger: 'blur' },
          { max: 100, message: '长度最多 100 个字符', trigger: 'blur' }
        ],
        features: [
          { required: true, message: '请输入检测内容', trigger: 'blur' },
          { max: 150, message: '长度最多 150 个字符', trigger: 'blur' }
        ],
        testQualification: [
          { required: true, message: '请输入检测资质', trigger: 'blur' },
          { max: 100, message: '长度最多 100 个字符', trigger: 'blur' }
        ],
        sampleQuantity: [
          { required: true, message: '请输入抽样数量', trigger: 'blur' },
          { max: 100, message: '长度最多 100 个字符', trigger: 'blur' }
        ],
        cycleDays: [
          { required: false, message: '请输入服务周期', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const serviceCategoryId = this.info.serviceCategoryId
      return (serviceCategoryId ? '编辑' : '新增') + '套餐'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        serviceCategoryId: null,
        servicePackageId: null,
        servicePackageName: '',
        testStandard: '',
        features: '',
        testQualification: '',
        sampleQuantity: '',
        cycleDays: undefined
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.servicePackageId
            ? 'updateservicepackage'
            : 'addservicepackage'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              cycleDays: this.info.cycleDays || 0
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(serviceCategoryId) {
      this.info.serviceCategoryId = serviceCategoryId
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
